<div
  [id]="(darkMode ? 'dark-container-' : 'container-') + blogId"
  class="blog-shell"
  [ngClass]="{ 'dark-shell': darkMode }">
  <ng-content></ng-content>
</div>

